//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';

export interface ParamsType {
    user_id: number;
}

const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/staff/account-staff-basic-data/{user_id} -> get -> ${code}`);
    };
};

export const Response200IO = t.interface({
    assetFlowsUrl: t.string,
    cancelWithdrawal: t.union([t.null, t.undefined, t.boolean]),
    coolingOffPeriodHours: t.union([t.null, t.undefined, t.number]),
    createdAt: t.union([t.null, t.undefined, t.string]),
    email: t.union([t.null, t.undefined, t.string]),
    failedLoginAttempts: t.number,
    firstName: t.string,
    fullName: t.union([t.null, t.undefined, t.string]),
    id: t.number,
    ip: t.union([t.null, t.undefined, t.string]),
    jobTitle: t.string,
    kycStatus: t.string,
    marketing: t.union([t.null, t.undefined, t.boolean]),
    name: t.string,
    passwordResetToken: t.union([t.null, t.undefined, t.string]),
    passwordResetTokenUrl: t.string,
    personalId: t.union([t.null, t.undefined, t.string]),
    phone: t.union([t.null, t.undefined, t.string]),
    playBreakDuration: t.union([t.null, t.undefined, t.number]),
    playBreakExpiry: t.union([t.null, t.undefined, t.string]),
    playBreakRequestDate: t.union([t.null, t.undefined, t.string]),
    reactivationDate: t.union([t.null, t.undefined, t.string]),
    reactivationRequestedDate: t.union([t.null, t.undefined, t.string]),
    realityCheckFrequency: t.union([t.null, t.undefined, t.number]),
    realityCheckFrequencyDateSet: t.union([t.null, t.undefined, t.string]),
    realityCheckFrequencyRequestDate: t.union([t.null, t.undefined, t.string]),
    requestedRealityCheckFrequency: t.union([t.null, t.undefined, t.number]),
    resetPasswordUrl: t.string,
    revision: t.number,
    roles: t.array(t.string),
    selfExclusionDate: t.union([t.null, t.undefined, t.string]),
    selfExclusionDuration: t.union([t.null, t.undefined, t.number]),
    selfExclusionExpiry: t.union([t.null, t.undefined, t.string]),
    spOnlySports: t.union([t.null, t.undefined, t.array(t.string)]),
    srg: t.union([t.null, t.undefined, t.boolean]),
    statementsUrl: t.string,
    status: t.string,
    statusDescription: t.union([t.null, t.undefined, t.string]),
    surname: t.union([t.null, t.undefined, t.string]),
    tableauAccessLogin: t.string,
    terms: t.union([t.null, t.undefined, t.boolean]),
    transactionUrl: t.string,
    type: t.string,
    universe: t.string,
    universePrefix: t.string,
    url: t.string,
    walletUrl: t.string,
});
export type Response200Type = {
    assetFlowsUrl: string;
    cancelWithdrawal?: null | undefined | boolean;
    coolingOffPeriodHours?: null | undefined | number;
    createdAt?: null | undefined | string;
    email?: null | undefined | string;
    failedLoginAttempts: number;
    firstName: string;
    fullName?: null | undefined | string;
    id: number;
    ip?: null | undefined | string;
    jobTitle: string;
    kycStatus: string;
    marketing?: null | undefined | boolean;
    name: string;
    passwordResetToken?: null | undefined | string;
    passwordResetTokenUrl: string;
    personalId?: null | undefined | string;
    phone?: null | undefined | string;
    playBreakDuration?: null | undefined | number;
    playBreakExpiry?: null | undefined | string;
    playBreakRequestDate?: null | undefined | string;
    reactivationDate?: null | undefined | string;
    reactivationRequestedDate?: null | undefined | string;
    realityCheckFrequency?: null | undefined | number;
    realityCheckFrequencyDateSet?: null | undefined | string;
    realityCheckFrequencyRequestDate?: null | undefined | string;
    requestedRealityCheckFrequency?: null | undefined | number;
    resetPasswordUrl: string;
    revision: number;
    roles: Array<string>;
    selfExclusionDate?: null | undefined | string;
    selfExclusionDuration?: null | undefined | number;
    selfExclusionExpiry?: null | undefined | string;
    spOnlySports?: null | undefined | Array<string>;
    srg?: null | undefined | boolean;
    statementsUrl: string;
    status: string;
    statusDescription?: null | undefined | string;
    surname?: null | undefined | string;
    tableauAccessLogin: string;
    terms?: null | undefined | boolean;
    transactionUrl: string;
    type: string;
    universe: string;
    universePrefix: string;
    url: string;
    walletUrl: string;
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);

type ExtraHeadersType = Record<string, string>;

/**
 * @deprecated - Please use this method "openapiProxyStaffAccountStaffBasicDataRequest"
 */
export const openapi_proxy_staff_account_staff_basic_data = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<FetchGeneralRawResponseType> => {
    const query = '';
    const url = `${api_url}/api-proxy/staff/account-staff-basic-data/${params.user_id}${query}`;

    const method = 'GET';
    const paramsFetch = {
        url,
        body: undefined,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};

export type OpenapiProxyStaffAccountStaffBasicDataParamsType = ParamsType;

export type OpenapiProxyStaffAccountStaffBasicDataResponseType =
    | {
          status: 200;
          body: Response200Type;
      }
    | {
          status: 400;
          body: Response400Type;
      }
    | {
          status: 401;
          body: Response401Type;
      }
    | {
          status: 500;
          body: Response500Type;
      };

export type OpenapiProxyStaffAccountStaffBasicDataResponse200Type = Response200Type;

export const openapiProxyStaffAccountStaffBasicDataRequest = async (
    api_url: string,
    api_timeout: number,
    backendToken: string,
    params: ParamsType,
    extraHeaders?: ExtraHeadersType
): Promise<OpenapiProxyStaffAccountStaffBasicDataResponseType> => {
    const response = await openapi_proxy_staff_account_staff_basic_data(
        api_url,
        api_timeout,
        backendToken,
        params,
        extraHeaders
    );
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }

    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyStaffAccountStaffBasicDataRequest - unhandled response ${response.status}`);
};
